import { Time } from '~/components/elements/Time'
import { ClockIcon } from '~/components/icons/generated/ClockIcon'
import { dateFormatToYYYYMMDD } from '~/lib/dateUtil'

type Props = {
  updatedAt: string
}

export const UpdateDate: React.FC<Props> = ({ updatedAt }) => {
  const updatedDate = dateFormatToYYYYMMDD(updatedAt)
  return (
    <p className="flex gap-x-1 text-[11px] leading-normal text-black-400 xl:gap-x-[5px] xl:text-[14px]">
      <ClockIcon className="inline-block h-[13px] xl:h-[19px]" />
      <span className="inline-block">
        <Time dateTime={updatedAt}>{updatedDate}</Time>
        更新
      </span>
    </p>
  )
}
